import React, { useEffect, useState } from 'react';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import ModalFormVehiService from '../../components/forms/catalog/modal.form.vehicleServices';
import { get } from '../../services/back.service';

function ListVehicleService() {
  const [msgGet ,setMsgGet] = useState('');
  const [ServiceClasses,setServiceClasses] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });
  useEffect(() => {
    getService();
  }, []);

  const createServiceClasse = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getService();
  };


  const editButton = (row) => {
    return (
      <ModalFormVehiService
        title="Modificar Tipo Servicio"
        button_text="Editar"
        button_variant="outline-primary"
        vehiServiceSelect={row.id}
        callback={createServiceClasse}
      ></ModalFormVehiService>
    );
  };

  const getService = async()=>{
    const responsevehicleService = await get('/catalog/servicevehicle/',{})
    if(responsevehicleService.success){
      setServiceClasses(responsevehicleService.data);
    }else{
      setMsgGet(responsevehicleService.message)
    }       
  }

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormVehiService
        title="Crear Tipo Servicio"
        button_text="Crear Tipo Servicio"
        button_variant="primary"
        callback={createServiceClasse}
      ></ModalFormVehiService>
      <ListTables
        data={ServiceClasses}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListVehicleService;
